<template>
  <img src="~/assets/icon/icon-vk.svg" />
</template>
